import React from "react";
import { ProfileViews } from "../../../components/profile/ProfileView";
import img1 from "../../../assets/imgby_artist1.png";
import img2 from "../../../assets/imgby_artist2.png";
import img3 from "../../../assets/imgby_artist3.png";
import img4 from "../../../assets/imgby_artist4.png";
import img5 from "../../../assets/imgby_artist5.png";

export const ProfileView = () => {
  const user = {
    image: img1,
    name: "John Doe",
    username: "johnny",
    email: "john@example.com",
    location: "New York",
    artist_type: "Painter",
    experience: "5 years",
    skills: ["Sketching", "Digital Art", "Oil Painting"],
    bio: "I am a passionate artist who loves creating portraits and landscapes.",
  };

  const images = [img1, img2, img3, img4, img5, img1, img2, img3, img4, img5];

  return <ProfileViews user={user} images={images} />;
};
